<h1> Cart </h1>
<p>
	<!--<a routerLink="/shipping">Check Shipping Pricing</a>-->
	<a [routerLink]="['/shipping']">Check Shipping Pricing</a>
</p>
<div *ngIf="items">
	<div *ngFor="let item of items">
		<span>{{ item.name }}</span>
		<span>{{ item.price | currency}}</span>
	</div>
</div>

<form [formGroup]="checkoutForm" (ngSubmit)="onSubmit(checkoutForm.value)">
	<div>
		<label for="name">Name</label>
		<input id="name" type="text" formControlName="name">
  </div>

  <div>
    <label for="address">
    Address
    </label>
    <input id="address" type="text" formControlName="address">
  </div>
	<button class="button" type="submit">Complete your order</button>
</form>